<template>
  <div class="user-invite user-edit popup" :class="{ '-show': popup.show }">
    <div class="layout" @click="togglePopup"></div>
    <div class="body">
      <div class="wrapper">
        <h2>Приглашение</h2>
        <div class="-row">
          <div class="-cell">
            <label>Email</label>
          </div>
          <div class="-cell">
            <input
              name="email"
              @input="inputHandle"
              type="email"
              placeholder="new@serenity.ru"
            />
          </div>
        </div>
        <div class="-row">
          <div class="-cell">
            <label>Роль</label>
          </div>
          <div class="-cell">
            <custom-select-multiple
              :name="'Role'"
              @valuesSelected="valuesSelected"
              :options="Role"
            />
          </div>
        </div>
        <div class="-row">
          <div class="-cell">
            <label>Направление</label>
          </div>
          <div class="-cell">
            <custom-select-multiple
              :name="'Directions'"
              @valuesSelected="valuesSelected"
              :options="Directions"
            />
          </div>
        </div>
        <div v-if="data.admin" class="-row">
          <div class="-cell">
            <label>Администратор</label>
          </div>
          <div class="-cell">
            <custom-switch
              :name="'admin'"
              @toggle="toggle"
              :checked="popup.data.admin"
            />
          </div>
        </div>
        <div class="-row">
          <div class="-cell">
            <label>Активный профиль</label>
          </div>
          <div class="-cell">
            <custom-switch
              :name="'active'"
              @toggle="toggle"
              :checked="popup.data.active"
            />
          </div>
        </div>
        <div class="action">
          <button @click="togglePopup">закрыть</button>

          <button @click="userInvite" class="-blue">пригласить</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      Role: [],
      Directions: [],
      save: false
    };
  },
  computed: {
    ...mapState("user", ["data"]),
    ...mapState("app", ["popup", "roles", "directions"]),
    ...mapGetters("app", ["resolveUser"]),
    notSelf() {
      return this.popup.data.email !== this.data.email;
    }
  },
  methods: {
    ...mapActions("app", [
      "togglePopup",
      "setPopupValue",
      "inviteUser",
      "getUsersList"
    ]),

    toggle(values) {
      this.save = true;
      this.setPopupValue(values);
    },
    inputHandle(ev) {
      const { name, value } = ev.target;
      this.setPopupValue({ name, value });
    },
    async userInvite() {
      await this.inviteUser(this.popup.data);
      await this.getUsersList();
      this.togglePopup();
    },
    valuesSelected({ name, option }) {
      this.save = true;
      if (option.value !== 0) {
        this.save = true;
        this[name].map(v => {
          if (option.value === v.value) v.selected = !option.selected;
        });
        const endValues = this[name].filter(v => v.selected).map(v => v.value);

        const zeroIndex = endValues.findIndex(v => v.value === 0);
        if (zeroIndex > -1) endValues.splice(zeroIndex, 1);

        const selectedIndex = this[name].findIndex(v => v.value === 0);
        if (selectedIndex > -1) this[name][selectedIndex].selected = false;

        this.setPopupValue({
          name: name.toLowerCase(),
          value: endValues
        });
      } else {
        this[name].map(v => (v.selected = v.value === 0));
        this.setPopupValue({
          name: name.toLowerCase(),
          value: [0]
        });
      }
    },
    prepareSelect() {
      this.Role = this.roles.map(role => {
        return {
          title: role.name,
          value: role.id,
          selected: this.popup.data.role.includes(role.id)
        };
      });
      this.Directions = this.directions.map(role => {
        return {
          title: role.name,
          value: role.id,
          selected: this.popup.data.directions.includes(role.id)
        };
      });
    }
  },
  mounted() {
    this.prepareSelect();
  }
};
</script>
